import React from 'react';

import { ChipDaRegua, COR_DO_ESTADO, EstadoDoChip, ROTULO_DO_ESTADO } from '../../views/home/regua.util';
import '../../shared/ui/regua-esteiras.css';

/**
 * Régua com TODAS as esteiras ativas de um veículo (at-130).
 *
 * Os chips são os mesmos do card do kanban (`shared/ui/regua-esteiras.css`) e as cores vêm da
 * mesma regra (`derivarReguaDoVeiculo`), então os rótulos são os da legenda da Home: o chip
 * esmaecido é **Fora do planejamento** — a esteira existe na oficina, mas não está no plano deste
 * veículo.
 */
interface ReguaEsteirasProps {
  chips: ChipDaRegua[];
  comLegenda?: boolean;
}

const ORDEM_DA_LEGENDA: EstadoDoChip[] = ['atual', 'realizada', 'inacabada', 'paralela', 'prevista', 'sistema'];

const ReguaEsteiras: React.FC<ReguaEsteirasProps> = ({ chips, comLegenda = false }) => (
  // ⚠️ `.regua-esteiras` dá escopo às regras: fora do `.ConteDo` (os modais), o `.Etapas { height: 21px }`
  // e o `.Etapa { width: 60px }` de comissionamentos.css venciam e os chips invadiam a legenda.
  <div className="regua-esteiras">
    <div className="Etapas">
      {chips
        .filter((s) => !s.oculto)
        .map((s) => {
          const estado = s.foraDoPlanejamento ? 'Fora do planejamento' : ROTULO_DO_ESTADO[s.estado];
          return (
            <div
              key={s.id}
              className={`Etapa chip chip--${s.cor} ${s.cor} ${s.foraDoPlanejamento ? 'chip--disabled' : ''}`}
              title={`${s.nome}: ${estado}`}
            >
              <div
                className="EtapaTexto"
                style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', fontSize: 10 }}
              >
                {s.nome}
              </div>
            </div>
          );
        })}
    </div>
    {comLegenda && (
      <div className="regua-legenda">
        {ORDEM_DA_LEGENDA.map((estado) => (
          <span key={estado} className="regua-legenda-item">
            <span className={`chip chip--${COR_DO_ESTADO[estado]} regua-legenda-amostra`} />
            {ROTULO_DO_ESTADO[estado]}
          </span>
        ))}
        <span className="regua-legenda-item">
          <span className="chip chip--red chip--disabled regua-legenda-amostra" />
          Fora do planejamento
        </span>
      </div>
    )}
  </div>
);

export default ReguaEsteiras;
